module.exports = __webpack_public_path__ + "static/media/brasil.897e3318.svg";